
import React, { useMemo } from 'react';
import type { Chef, Language, Recipe, UserMealPreferences } from '../types';
import ChefProfileCard from './ChefProfileCard';

interface ChefProfileModalProps {
    isOpen: boolean;
    onClose: () => void;
    chef: Chef | null;
    recipes?: Recipe[];
    language?: Language;
    userMealPreferences?: UserMealPreferences | null;
    onToggleFavoriteChef?: (chefId: string) => Promise<void>;
    onViewRecipes?: (chefId: string) => void;
    onEdit?: () => void;
}

const ChefProfileModal: React.FC<ChefProfileModalProps> = ({
    isOpen,
    onClose,
    chef,
    recipes = [],
    language = 'en',
    userMealPreferences = null,
    onToggleFavoriteChef,
    onViewRecipes,
    onEdit,
}) => {
    const recipeCount = useMemo(() => {
        if (!chef) return 0;
        return recipes.filter((r) => !r.isDeleted && r.chefId === chef.id).length;
    }, [chef, recipes]);

    if (!isOpen || !chef) return null;

    return (
        <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[600] flex items-center justify-center p-4 animate-fade-in"
            onClick={onClose}
        >
            <div className="w-full max-w-sm my-4" onClick={(e) => e.stopPropagation()}>
                <ChefProfileCard
                    chef={chef}
                    recipeCount={recipeCount}
                    language={language}
                    userMealPreferences={userMealPreferences}
                    onToggleFavoriteChef={onToggleFavoriteChef}
                    onViewRecipes={onViewRecipes}
                    onEdit={onEdit}
                    onClose={onClose}
                />
            </div>
        </div>
    );
};

export default ChefProfileModal;
